import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f64ef60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "home_content" }
const _hoisted_3 = { class: "form_box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_7 = { class: "control" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("合并开票")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-text" }, "表格任意单元格双击均可自动复制（仅支持高版本浏览器）", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("普票")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("个人")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("专票")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("待开票")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("已开票")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("登录失败")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("异常")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("开票")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("重试")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("异常查询")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("退款")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("忽略")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("退回")
const _hoisted_26 = { class: "pages" }
const _hoisted_27 = { class: "dialog-footer" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 取消 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 确认 ")

import moment from "moment"
import { ref, onMounted, reactive } from 'vue'
import useClipboard from "vue-clipboard3";
import Menu from '../../components/Menu.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import {useRouter} from 'vue-router'
import {POSTAuth, GETAuth, POST} from '@/service/index'
import type { FormInstance } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(false)
const router = useRouter();
const ruleFormRef = ref<FormInstance>();

const { toClipboard } = useClipboard()

const copyInfoHandler = (row:any, cell:any) => {
  copyInfo(row[cell.property])
}

const copyInfo = async (str:string) => {
  try {
    await toClipboard(str)
    ElMessage.success('复制成功')
  } catch (e) {
    ElMessage.error('复制失败')
  }
}
const checkStatus = (row:any) => {
  return row.invoices === 0 || row.invoices === 8 || row.invoices === 9 || row.invoices === 1 || ( row.ignoreInvoice === 1 && row.invoices === 0 );
}

const ids = ref([]);
const keys = ref([]);
let openInvoiceFlag = true;

const options:any = ref([
  { label: '待开票', value: 0 },
  { label: '已开票', value: 2 },
  { label: '登录失败', value: 8 },
  { label: '异常', value: 9 },
])

const options2:any = ref([
  { label: '未忽略', value: 1 },
  { label: '已忽略', value: 0 },
])

const options3:any = ref([
  { label: '普票', value: 'INV_001' },
  { label: '专票', value: 'INV_003' },
  { label: '个人', value: 'INV_002' },
])

const options4:any = ref([
  { label: '否', value: 0 },
  { label: '是', value: 1 },
])
let beginTime = moment().startOf('year').format('YYYY-MM-DD');
let endTime =  moment().add(1, "days").format("YYYY-MM-DD");

const recordBase:any = ref([])

onMounted(() => {
  getRecord()
})

const handleClick = (e:any) => {
  console.log(e)
}

const params = reactive({
  beginTime: beginTime,
  endTime: endTime,
  ignoreInvoice: 1,
  index: 1,
  pageSize: 20,
  combine: null,
  invoices: null,
  invoiceCode: null,
  studentName: null,
  isAppyInvoice: null,
  invoiceTitle: null,
  idCardNo: null,
})

const pagesValue = ref(0)
const totalValue = ref(0)

const search = () => {
  params.index = 1
  getRecord();
}

const rules = ref([
    {
      taxNo: [
        { required: true, message: '请输入纳税人唯一编码', trigger: 'blur' },
      ],
      invoiceTitle: [
        { required: true, message: '请输入开票抬头', trigger: 'blur' },
      ],
    }
])

const editInfoVisible:any = ref(false);
const editInfoForm:any = reactive({
  taxNo: null,
  id: null,
  invoiceTitle: null,
  invoiceCode: null,
})
const editInfo = (row:any) => {
  editInfoVisible.value = true;
  editInfoForm.taxNo = row.taxNo;
  editInfoForm.id = row.id;
  editInfoForm.invoiceTitle = row.invoiceTitle;
  editInfoForm.invoiceCode = row.invoiceCode;
}

const editInfoHandler = async () => {
  debugger
  let { data } = await POST(`/invoice/edit`, { ...editInfoForm });
  loading.value = false
  if ( data.code === 200 ) {
    let { msg } = data;
    ElMessage.success(msg)
    await getRecord();
    editInfoVisible.value = false
  }
}

const handleSelectionChange = (event:any)  => {
  ids.value = [];
  keys.value = [];
  let tempIds:any = []
  event.forEach((it:any) => {
    if ( tempIds.length === 0 ) {
      tempIds.push(it.taxNo);
    } else {
      let item = tempIds.find((j: string) => j === it.taxNo)
      if (!item) {
        tempIds.push(it.taxNo)
      }
    }
  })
  if ( tempIds.length > 1 ) {
    ElMessage.error("请选择同一个企业合并开票")
  }
  ids.value = tempIds;
  keys.value =Object.assign([], event);
}

const tryOpenInvoice = (row:any) => {
  if ( /[\s\u3000]/.test(row.taxNo) ) {
    return ElMessage.error("纳税人唯一编码不能包含空格");
  }
  ElMessageBox.confirm('是否重试开票','提示',{
    confirmButtonText: '确认开票',
    cancelButtonText: '取消开票',
    type: 'warning',
  }).then(() => {
    invoiceHandler(row.recordCode);
  }).catch(() => {
    console.log(1)
  })
}

const markOpenInvoice = () => {
  if (keys.value.length === 0) {
    return ElMessage.error("请先选择要开票的记录")
  }
  if (ids.value.length > 1) {
    return ElMessage.error("请选择同一个企业合并开票")
  }
  const list = keys.value.map((it:any) => it.recordCode)
  ElMessageBox.prompt('请输入发票号', '开票', {
    confirmButtonText: '确认开票',
    cancelButtonText: '取消开票',
    inputPattern: /\S+/,
    inputErrorMessage: '发票号不能为空',
    type: 'warning',
  }).then(({ value }: any) => {
    const invoiceNo = String(value).trim()
    if (!invoiceNo) {
      return ElMessage.error('发票号不能为空')
    }
    markInvoiceHandler(list.join(','), invoiceNo)
  }).catch(() => {
    // 用户取消
  })
}

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.resetFields();
  params.index = 1
  getRecord();
}

const ignore = async (id:any) => {
  loading.value = true
  try {
    let { data } = await POSTAuth(`/invoice/ignore/${id}`);
    loading.value = false
    if ( data.code === 200 ) {
      let { msg } = data;
      ElMessage.success(msg)
      await getRecord();
    }
  } catch (e) {
    loading.value = false
    ElMessage.error('操作失败请重试')
  }
}

const refund = async (id:any) => {
  loading.value = true
  try {
    let { data } = await POSTAuth(`/invoice/refund/${id}`);
    loading.value = false
    if ( data.code === 200 ) {
      let { msg } = data;
      ElMessage.success(msg)
      await getRecord();
    }
  } catch (e) {
    loading.value = false
    ElMessage.error('操作失败请重试')
  }
}

const reject = async (id:any) => {
  loading.value = true
  try {
    let { data } = await POSTAuth(`/invoice/reject/${id}`);
    loading.value = false
    if ( data.code === 200 ) {
      let { msg } = data;
      ElMessage.success(msg)
      await getRecord();
    }
  } catch (e) {
    loading.value = false
    ElMessage.error('操作失败请重试')
  }
}

const openWarningInvoice  = async(serialNo: string) => {
  let { data: { code, msg } } = await GETAuth(`/invoice/warning/${serialNo}`);
  loading.value = false
  if ( code === 200 ) {
    ElMessage.success(msg)
    await getRecord();
  } else {
    ElMessage.error(msg)
  }
}

const invoiceHandler = async (ids:any) => {
  if ( openInvoiceFlag === false ) {
    return
  }
  openInvoiceFlag = false;
  loading.value = true
  try {
    let { data: { code, msg } } = await POSTAuth(`/invoice/open`,  { ids: ids });
    loading.value = false
    openInvoiceFlag = true;
    if ( code === 200 ) {
      ElMessage.success(msg)
      await getRecord();
    } else {
      ElMessage.error(msg)
    }
  } catch (e) {
    loading.value = false
    ElMessage.error('开票失败请重试')
  }
}

const markInvoiceHandler = async (ids:any, invoiceNO:string) => {
  if ( openInvoiceFlag === false ) {
    return
  }
  openInvoiceFlag = false;
  loading.value = true
  try {
    let { data: { code, msg } } = await POSTAuth(`/invoice/mark_invoice`,  { ids, invoiceNO });
    loading.value = false
    openInvoiceFlag = true;
    if ( code === 200 ) {
      ElMessage.success(msg)
      await getRecord();
    } else {
      ElMessage.error(msg)
    }
  } catch (e) {
    loading.value = false
    ElMessage.error('开票失败请重试')
  }
}

const openInvoice = (row:any) => {
  ElMessageBox.confirm('是否开票','提示',{
    confirmButtonText: '确认开票',
    cancelButtonText: '取消开票',
    type: 'warning',
  }).then(() => {
    invoiceHandler(row.recordCode)
  }).catch(() => {
    console.log(1)
  })
}

const selectable = (row:any) => {
  return row.invoices !== 0 ? false : true
}

const getRecord = async () => {
  loading.value = true
  let { data } = await GETAuth(`/invoice/other/list`, {
    params
  })
  loading.value = false
  if ( data.code === 200 ) {
    let { records, pages, total } = data.data
    recordBase.value =records
    pagesValue.value = pages
    totalValue.value = total
  }
}

const currentChangeHandler = (e:string) => {
  params.index = e
  getRecord()
}

// 按当前筛选条件导出全量数据（不含分页参数）
const exportExcel = async () => {
  const query:any = { ...params }
  delete query.index
  delete query.pageSize
  loading.value = true
  try {
    const res:any = await GETAuth(`/invoice/other/export`, {
      params: query,
      responseType: 'blob'
    })
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `第三方发票_${moment().format('YYYYMMDDHHmmss')}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (e) {
    ElMessage.error('导出失败请重试')
  } finally {
    loading.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Menu, { index: "6" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          inline: true,
          model: _unref(params),
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "开始日期",
              prop: "beginTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  style: {"width":"150px"},
                  modelValue: _unref(params).beginTime,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(params).beginTime) = $event)),
                  type: "date",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "选择开始日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "结束日期",
              prop: "endTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  style: {"width":"150px"},
                  modelValue: _unref(params).endTime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(params).endTime) = $event)),
                  type: "date",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "选择结束日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "开票抬头",
              prop: "invoiceTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(params).invoiceTitle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(params).invoiceTitle) = $event)),
                  style: {"width":"200px"},
                  clearable: "",
                  placeholder: "请输入开票抬头"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "发票类型",
              prop: "invoiceCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(params).invoiceCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(params).invoiceCode) = $event)),
                  style: {"width":"130px"},
                  clearable: "",
                  placeholder: "选择发票类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options3.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "是否合并开票",
              prop: "combine"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(params).combine,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(params).combine) = $event)),
                  style: {"width":"130px"},
                  clearable: "",
                  placeholder: "选择类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options4.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "学员姓名",
              prop: "studentName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(params).studentName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(params).studentName) = $event)),
                  style: {"width":"150px"},
                  clearable: "",
                  placeholder: "请输入学员姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "证件号",
              prop: "idCardNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(params).idCardNo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(params).idCardNo) = $event)),
                  clearable: "",
                  placeholder: "请输入证件号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "忽略",
              prop: "ignoreInvoice"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(params).ignoreInvoice,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(params).ignoreInvoice) = $event)),
                  style: {"width":"200px"},
                  clearable: "",
                  placeholder: "是否忽略"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options2.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "开票",
              prop: "invoices"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(params).invoices,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(params).invoices) = $event)),
                  style: {"width":"200px"},
                  clearable: "",
                  placeholder: "开票状态"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (resetForm(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: exportExcel
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: markOpenInvoice,
            disabled: _unref(openInvoiceFlag) === false || ids.value.length === 0 || ids.value.length > 1
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _hoisted_9
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: recordBase.value,
        stripe: "",
        "row-key": "recordCode",
        onSelectionChange: handleSelectionChange,
        onCellDblclick: copyInfoHandler
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            selectable: selectable,
            width: "55"
          }),
          _createVNode(_component_el_table_column, {
            prop: "combine",
            align: "center",
            label: "合并",
            width: "60"
          }, {
            default: _withCtx((scope) => [
              (scope.row.combine === 1)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_11))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "studentName",
            align: "left",
            label: "姓名"
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoiceCode",
            align: "center",
            label: "发票类型"
          }, {
            default: _withCtx((scope) => [
              (scope.row.invoiceCode === 'INV_001')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (scope.row.invoiceCode === 'INV_002')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }))
                : (scope.row.invoiceCode === 'INV_003')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "taxNo",
            align: "left",
            label: "纳税人唯一编码"
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoiceTitle",
            align: "left",
            label: "开票抬头"
          }),
          _createVNode(_component_el_table_column, {
            prop: "courseName",
            align: "left",
            label: "课程名称"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.courseName.replaceAll(' ', '')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "courseFee",
            align: "right",
            label: "开票金额"
          }),
          _createVNode(_component_el_table_column, {
            prop: "buyerPhone",
            align: "right",
            label: "手机号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "buyerEmail",
            align: "left",
            label: "邮箱"
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoicesNoHide",
            align: "left",
            width: "120",
            label: "发票号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "serialNo",
            align: "left",
            width: "120",
            label: "申请流水号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "payTime",
            align: "left",
            width: "170",
            label: "支付日期"
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoices",
            width: "90",
            label: "是否开票"
          }, {
            default: _withCtx((scope) => [
              (scope.row.invoices === 0)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (scope.row.invoices === 2)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (scope.row.invoices === 8)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (scope.row.invoices === 9)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 3,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoiceRemark",
            label: "财务备注"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            width: "350",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              (scope.row.ignoreInvoice === 1 && scope.row.invoices === 0 && (scope.row.invoiceCode === 'INV_001' || scope.row.invoiceCode === 'INV_003') )
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (editInfo(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.invoices === 0)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "small",
                    type: "danger",
                    onClick: ($event: any) => (openInvoice(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.invoices === 8)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    size: "small",
                    type: "warning",
                    onClick: ($event: any) => (tryOpenInvoice(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.invoices === 9)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    size: "small",
                    type: "warning",
                    onClick: ($event: any) => (openWarningInvoice(scope.row.serialNo))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.invoices === 0)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 4,
                    title: "是否确认退款？",
                    onConfirm: ($event: any) => (refund(scope.row.recordCode))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true),
              (scope.row.ignoreInvoice === 1 && scope.row.invoices === 0)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 5,
                    title: "是否要忽略开票申请？",
                    onConfirm: ($event: any) => (ignore(scope.row.recordCode))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true),
              (scope.row.ignoreInvoice === 1 && scope.row.invoices === 0)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 6,
                    title: "是否要退回开票申请？",
                    onConfirm: ($event: any) => (reject(scope.row.recordCode))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_pagination, {
          background: "",
          "hide-on-single-page": true,
          "page-size": _unref(params).pageSize,
          "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => ((_unref(params).pageSize) = $event)),
          "current-page": _unref(params).index,
          "onUpdate:current-page": _cache[11] || (_cache[11] = ($event: any) => ((_unref(params).index) = $event)),
          "page-sizes": [10, 20, 50, 100, 200, 300],
          layout: "sizes, total, prev, pager, next",
          total: totalValue.value,
          onSizeChange: getRecord,
          onCurrentChange: currentChangeHandler
        }, null, 8, ["page-size", "current-page", "total"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: editInfoVisible.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editInfoVisible).value = $event)),
      title: "修改开票信息",
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_button, {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (editInfoVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: editInfoHandler
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(editInfoForm),
          rules: "rules",
          "label-position": "right",
          "label-width": "130px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "开票类型",
              prop: "invoiceCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(editInfoForm).invoiceCode,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(editInfoForm).invoiceCode) = $event)),
                  placeholder: "请选择开票类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options3.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "开票抬头",
              prop: "invoiceTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(editInfoForm).invoiceTitle,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(editInfoForm).invoiceTitle) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_unref(editInfoForm).invoiceCode !== 'INV_002')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "纳税人唯一编码",
                  prop: "taxNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(editInfoForm).taxNo,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(editInfoForm).taxNo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})